module.exports = __webpack_public_path__ + "data/config.59bc2b.json";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/config.json5
 ** module id = 64
 ** module chunks = 0
 **/